module.exports = __webpack_public_path__ + "img/kbeauty-2.39c8bf18.png";